<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm6 md6 lg6>
        <v-card >
        <v-card-text class="headline">Компонент не реализован пока</v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
    }),
    methods: {
    }
  }
</script>


// WEBPACK FOOTER //
// NotImplemented.vue?48f67cb5